export enum TimeTrackerMenuTabs {
  workingTime = 'workingTime',
  projectTime = 'projectTime',
}
